import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.map";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.promise.finally";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.weak-map";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import { END } from 'redux-saga';
export var decorateStore = function decorateStore(store, sagaMiddleware) {
  /* Internal Methods */
  var runningTasks = new Map();
  var runningTaskRefs = new WeakMap();

  var cleanUpTask = function cleanUpTask(saga, task) {
    // Clean up task that finished running.
    // Guard against accidentally removing a newly started task.
    if (task === runningTasks.get(saga)) {
      runningTasks.delete(saga);
    }
  };

  var cancelAllTasks = function cancelAllTasks() {
    runningTasks.forEach(function (task) {
      return task.cancel();
    });
    runningTasks.clear();
  };

  var createTask = function createTask(saga) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var task = sagaMiddleware.run.apply(sagaMiddleware, [saga].concat(args));
    task.done.finally(function () {
      return cleanUpTask(saga, task);
    });
    runningTasks.set(saga, task);
    runningTaskRefs.set(task, 0);
    return task;
  };

  var incrementRefCount = function incrementRefCount(task) {
    runningTaskRefs.set(task, runningTaskRefs.get(task) + 1);
  };

  var decrementRefCount = function decrementRefCount(task) {
    runningTaskRefs.set(task, runningTaskRefs.get(task) - 1);
  };

  var taskShouldStop = function taskShouldStop(task) {
    return runningTaskRefs.get(task) < 1;
  };
  /* External Methods */


  var close = function close() {
    return store.dispatch(END);
  };

  var runSaga = function runSaga(saga) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    var task = runningTasks.has(saga) ? runningTasks.get(saga) : createTask.apply(void 0, [saga].concat(args));
    incrementRefCount(task);
    return task;
  };

  var stopSaga = function stopSaga(saga) {
    if (runningTasks.has(saga)) {
      var task = runningTasks.get(saga);
      decrementRefCount(task);

      if (taskShouldStop(task)) {
        task.cancel();
        runningTasks.delete(saga);
      }
    }
  };

  return Object.assign(store, {
    close: close,
    runningTasks: runningTasks,
    runSaga: runSaga,
    stopSaga: stopSaga,
    cancelAllTasks: cancelAllTasks,
    runSagaOnce: createTask
  });
};